export const URLS = {
  SubmitTripReport: `https://jets-qsms.com/brokers`,
  GetIp: 'https://api.db-ip.com/v2/free/self',
  FlightawareTail: 'https://flightaware.com/live/flight/:tailNo',
  SafeCharge: 'https://cdn.safecharge.com/safecharge_resources/v1/websdk/safecharge.js',
  GoogleMapsApi: 'https://maps.googleapis.com/maps/api/js',
  FetchToken: '/authenticate',
  FetchTokenSSO: '/authenticate-sso',
  FetchRefreshToken: '/refreshaccesstoken',
  GetSalesforceOpportunityEmbedTarget: '/canvas/opportunity/:recordId',
  OpportunityLoss: '/salesforce/opportunity/:source/:id/loss',
  AuthenticateUser: '/authenticate',
  BulkResend: '/agreement/jc-terms-conditions/resend/bulk',
  CreateJetCardTermsConditions: '/agreement/jc-terms-conditions',
  GetJetCardTermsConditions: '/agreement/jc-terms-conditions/:agreementId',
  DeleteJetCard: '/jetcard',
  AircraftDelete: 'master/aircraft/delete/',
  GetClientCardPreviewDetails: '/jetcard/cardclientpreview',
  GetAgreementPdf: '/agreement/terms-and-conditions/pdfwithuid',
  GlobalSearch: '/globalsearch',
  GlobalSearchJetCardList: '/globalsearch/jetcard',
  GlobalSearchContactList: '/globalsearch/contact',
  GlobalSearchAccountList: '/globalsearch/account',
  GetNewToken: '/getTokenByRefreshToken',
  CreateContact: '/contacts/client',
  Getallassignedbrokers: '/contacts/getallassignedbrokers',
  GetContacts: '/contacts',
  GetCountries: '/country',
  CreateJetCard: '/contacts/jetcard',
  GetJetCardPromotion: '/contacts/jetcard/promotions',
  JetCardPromotion: '/contacts/jetcard/promotion',
  UpdatePromotionStatus: '/contacts/jetcard/promotion/status',
  DeletePromotion: '/contacts/jetcard/promotion/delete',
  PromotionClients: '/contacts/jetcard/promotion/clients',
  EligiblePromotions: '/contacts/jetcard/promotions/eligible',
  FlightCreditTypes: '/flight-credits/types',
  LeadershipApprovedCredits: '/flight-credits/leadership-approved',
  GetFlightCredits: '/contacts/flight-credits/:clientId',
  GetFlightCreditsByJetCards: '/flight-credits/jetcards/:clientId',
  DeleteFlightCredit: '/flight-credits/:creditId',
  AdHocCredits: '/flight-credits/ad-hoc',
  ValidateContact: '/contacts/client/validate',
  UpdatePersonalInfo: '/contacts/personalinfo',
  GetClientEmails: '/contacts/client/email/',
  GetAccountEmails: '/contacts/client/email/account/',
  GetUserEmails: '/acl/user/email/',
  // '/user', not '/acl/user/': the API Gateway registers the user list under the bare prefix and
  // only the email and activitylog routes under /acl/user. An unregistered path is rejected by the
  // gateway with a 403 that never reaches OSL or core, and the app hard-redirects on any 403.
  GetUsers: '/user',
  GetClientBrokers: '/contacts/brokerinfo/',
  GetClientPassenger: '/passenger/passengers/',
  GetAvailablePassengerContacts: '/passenger/passengers/available-contacts/',
  GetClientPreferences: '/contacts/preferences/:clientId',
  UpdateClientPreferences: '/contacts/preferences/:clientId',
  AuthorizeAgreement: '/agreement/authorizeagreement',
  GetConfiguration: '/configuration/getconfiguration',
  GetTermsAndConditions: '/agreement/terms-and-conditions/gettermandcondition',
  GetMinDailyHours: '/contacts/jetcard/jet-cards-daily-hours',
  GetAircraftRates: '/contacts/jetcard/jet-cards-type-rate',
  GetTaxSurcharge: '/agreement/jetcard/tax-surchage',
  UpdateJetCardDisplayName: '/agreement/jetcard/displayname',
  GetJetCardDetails: '/agreement/jetcard',
  GetClientCardDetails: '/jetcard/cardclientview',
  JetCardTransaction: '/jetcard/transaction',
  PostJetCardResend: '/agreement/terms-and-conditions/resend',
  GetBrokerAssignmentUserName: '/user/brokerassignment/users',
  GetBrokerAssignment: '/user/brokerassignment',
  GetContactNotesByClientId: '/contacts/notes/client-id',
  UpdateContactNotes: '/contacts/notes',
  UpdateJetCardRates: '/configuration/jet-cards-type-rate',
  GetJetCardIdByContacts: '/contacts/jetcard/dropdown',
  GetTripIdByContacts: '/trip/trip/dropdown',
  GetContactJetCardList: '/contacts/jetcard/overview',
  GetContactBillingAndClientNotes: '/contacts/jetcard/client-notes-and-billing-notes',
  UpdateJetCardBalanceStatement: '/jetcard/balance-statement',
  GetTripListing: '/trip',
  GetTripCalendar: '/trip/calendar',
  GetTripCalendarFilterOptions: '/trip/calendar/filter-options',
  GetTripCalendarItinerary: '/trip/calendar/:tripId',
  GetTripLegs: '/trip/legs',
  AutopopulateInternationalPeak: '/trip/legs/autopopulate',
  TripBulkEdit: '/trip/bulk/brokers',
  GetTripAirports: '/trip/airports',
  Wyvernrating: '/master/wyvernrating',
  Priorityrating: '/master/priorityrating',
  Phonetype: '/master/phonetype',
  Argusrating: '/master/argusrating',
  Aircrafttype: '/master/aircrafttype',
  Emailtype: '/master/emailtype',
  AvinodeidExist: '/master/operator/avinodeidexist',
  GetPaxCapacity: 'master/aircraft/paxcapacity',
  Fleet: '/master/fleet',
  AircraftName: '/master/aircraft-name',
  GetTripAircraft: '/trip/aircraft',
  GetTripOperator: '/trip/operator',
  GetTripFBO: '/trip/fbo',
  GetSpecialRequestTypes: '/trip/specialrequesttypes',
  GetTripOverview: '/trip/:tripId',
  GetTripLegsByTripId: '/trip/scenariolegs/:tripId',
  GetTripSpecialRequestByTripId: '/trip/specialrequest/:tripId',
  PostTripOverview: '/trip/create',
  PutTripOverview: '/trip/update',
  GetTripDetailsByTripId: '/trip/detail/:tripId',
  GetFullTripDetailsByTripId: '/trip/detail/:tripId/full',
  GetAcceptedTripDetailsByTripId: '/trip/detail/:tripId/accepted',
  GetTripReportsByTripId: '/trip/:tripId/report',
  GetTripReportsDashboard: '/trip/report',
  GetTripReportDetailsById: '/trip/report/:reportId',
  PostTripReport: '/trip/report',
  PostTripReportIssue: '/trip/report/:reportId/issue',
  GetTripLegsScenarios: '/trip/legsscenarios/:tripId',
  GetEditTripLegsOptions: '/trip/legsoptions/:tripId',
  CreateOption: '/trip/legsoptions',
  GetJCProposal: '/trip/proposal/jetcard/:tripId',
  GetJCDetails: '/agreement/jetcard/:jcId',
  CreateProposal: '/trip/proposal/jetcard',
  CreateCharterProposal: '/trip/proposal/charter',
  SendTripReminderEmail: '/trip/proposal/reminderemail/:tripId',
  SendTripReminderSms: '/trip/proposal/sendsmsreminder/:tripId',
  ContactPaymentInformation: '/contacts/paymentinfo/:clientId',
  GetTripDetailsByTripIdAndHash: '/trip/clientreview/:tripId/:hash',
  GetInvoiceDetailsByTripIdAndHash: '/trip/clientreview/invoice/:tripId/:hash',
  GetInvoiceDetailsByTripId: '/trip/invoice/:tripId',
  PostProposalAccepted: '/trip/proposal/accept',
  DownloadTripContract: '/trip/downloadcontract/:tripId',
  DownloadTripContractForClient: '/trip/clientreview/downloadcontract/:tripId/:hash',
  DownloadInvoiceByTripIdAndHash: '/trip/clientreview/invoice/:tripId/:hash/download',
  DownloadInvoiceByTripId: '/trip/invoice/:tripId/download',
  DownloadTripItinerary: '/trip/manage/itinerarydownload',
  DeletePaymentInfoByTripIdAndPayId: '/trip/clientreview/paymentinfo/:tripId/:hash/:payId',
  TripManage: '/trip/manage/makeassignment',
  UpdateTripManageLeg: '/trip/manage/updatelegsassignment',
  TripManageFinanceAdjustment: '/trip/manage/financeadjustment',
  TripManageConfirmSendToFinance: '/trip/manage/statusupdate/:tripId',
  PostFetchFinanceTripList: '/trip/tripsfinanceview',
  GetFinanceSendInvoice: '/trip/manage/sendinvoice/:tripId',
  FinanceOperatorList: '/trip/operator/payments',
  FinanceOperatorListExport: '/trip/operator/payments/export',
  GetFinanceOperatorList: '/trip/operator/payments/:legId',
  CancelTrip: '/trip/cancel',
  PostFetchFinanceOperatorList: '/trip/operator/payments',
  PostAssignPassengerToTrip: '/trip/detail/passengers',
  TripDownloadFiles: '/trip/files/:tripId',
  SendTripFiles: '/trip/files',
  UpdateTripFiles: '/trip/files/upload',
  SendDownloadTripFiles: '/trip/files/download',
  GetTripLegsByIds: '/trip/legs/tripids',
  PutTripReset: '/trip/:tripId',
  PostTripSearch: '/trip/dropdown',
  FileuploadUpload: 'fileupload/file/upload',
  GetPresignedUrl: 'fileupload/file/download',
  CreateTask: '/task',
  EditTask: '/task',
  GetTaskList: '/task',
  GetTaskTemplates: '/task/template',
  GetTaskTemplate: '/task/template/:id',
  CreateTaskTemplate: '/task/template',
  EditTaskTemplate: '/task/template',
  DeleteTaskTemplate: '/task/template/:id',
  ReactivateTaskTemplate: '/task/template/:id/reactivate',
  GetTaskTemplateTeamUsers: '/task/template/team/:teamId/users',
  GetTaskTags: '/task/tag',
  GetMyTaskTeams: '/task/my-teams',
  GetTaskFilterOptions: '/task/filter-options',
  GetTeams: '/team',
  GetSendTripFeedbackEmail: '/trip/feedback/email/:tripId',
  GetTripSubmitFeedback: '/trip/feedback/:tripId',
  GetTripSubmitFeedbackWithHash: 'trip/feedback/:tripId/submit-feedback/:hash',
  PostTripSubmitFeedbackWithHash: '/trip/feedback/:tripId/submit-feedback/:hash',
  GetClientFeedbackByHash: '/trip/feedback/external/:hash',
  PostClientFeedbackByHash: '/trip/feedback/external/:hash',
  GetClientFeedbackInternal: '/trip/feedback/:tripId/internal',
  GetTaskListByClientId: '/task/client/:clientId',
  ChangeTaskStatus: '/task/status',
  GetTaskListByTripId: '/task/trip/:tripId',
  DeleteTask: '/task/:taskId',
  GetActivityHistoryById: '/configuration/jet-cards-type-rate/auditlog/:jetCardTypeRateId',
  GetTripActivityLog: 'trip/:tripId/activitylog',
  GetTripLegActivityLog: 'trip/leg/:legId/activitylog',
  GetTaskListByFilter: 'task/filter',
  GetTripCount: 'trip/client/:clientId/tripcount',
  GetClientMargins: 'trip/client/:clientId/margins',
  GetPaymentSession: '/trip/:tripId/nuveisession/:hash',
  VisitNotification: '/notification/contactnotifications/visit',
  GetNotifications: '/notification/contactnotifications',
  GetActivityLogBroker: '/acl/user/:userId/activitylog',
  GetPersonalInfoActivityLog: 'contacts/personalinfo/activitylog/:contactId',
  GetIdentityInformationActivityLog: 'contacts/identityinformation/activitylog/:contactId',
  GetBrokerAssignmentsActivityLog: 'contacts/brokerinfo/activitylog/:contactId',
  GetClientActivityLog: 'contacts/client/activitylog/:contactId',
  GetSpouseInfoActivityLog: 'contacts/spouseinfo/activitylog/:contactId',
  GetAirportLabels: 'master/airport/labels',
  GetAirportMetros: 'master/airport/metros',
  //   Emails Trigger
  GetTriggerJetCardAgreementViewEmail: 'agreement/jetcard/clientreviewactivity/:jetCardId',
  GetTriggerTripProposalViewEmail: '/trip/clientreview/:tripId/activity',
  GetWeatherPoint: 'https://api.weather.gov/points/:lat,:lng',
  //   PDF Download
  GetJetCardTermsPDFByAgreementId: '/agreement/terms-and-conditions/download/:agreementId',
  GetTripTermsPDFByTripId: '/trip/terms-and-conditions/download/:tripId',
  GetDownloadedJetCardContractPDFUrl: '/jetcard/authorizeagreement/jetcardcontracts/:jetCardId',
  GetReportsById: '/reports',
  PostFrontendError: '/frontend-error',
  // Retool
  GetRetoolEmbedUrl: '/retool/embed-url',
  AdditionalTermsUrl: '/contacts/jetcard/promotions/additional-terms',
  ClientSegments: '/contacts/client-segments',
  CardDiscountTypes: '/contacts/card-discount-types',
  // Copilot (Internal endpoints)
  CopilotInviteClient: '/copilot/invite/:clientId',
  CopilotResendInvite: '/copilot/resend/:clientId',
  CopilotGetStatus: '/copilot/status/:clientId',
  CopilotResetPassword: '/copilot/reset-password/:clientId',
  // Avinode ETE
  GetAvinodeETE: '/avinode/ete',
  // Account detail page
  GetAccountList: '/account/accounts',
  GetAccountDetails: '/account/accounts/:accountId',
  GetAccountJetCards: '/account/accounts/:accountId/jet-cards',
  GetAccountFlightCredits: '/account/accounts/:accountId/flight-credits',
  GetAccountPassengers: '/account/accounts/:accountId/passengers',
  GetAccountPets: '/account/accounts/:accountId/pets',
  GetAccountTasks: '/account/accounts/:accountId/tasks',
  GetAccountNotes: '/account/accounts/:accountId/notes',
};

export const buildAPIURL = (url: string, paramReplacements?: Record<string, any>, queryParam?: Record<string, any>) => {
  if (paramReplacements) {
    url = replaceParams(url, paramReplacements);
  }
  if (queryParam) {
    url = addQueryParameters(url, queryParam);
  }
  return url;
};

const replaceParams = (url: string, params: Record<string, any>) => {
  Object.keys(params).forEach(k => {
    url = url.replace(`:${k}`, encodeURIComponent(params[k]));
  });
  return url;
};

export const addQueryParameters = (url: string, params: Record<string, any>) => {
  const queryList: Array<string> = [];
  Object.keys(params).forEach(k => {
    queryList.push(`${k}=${encodeURIComponent(params[k])}`);
  });
  const prefixCharacter = url.indexOf('?') === -1 ? '?' : '&';
  return `${url + prefixCharacter + queryList.join('&')}`;
};

export const currentRelativeUrl = (): string =>
  window.location.pathname + window.location.search + window.location.hash;

/**
 * External URLs and resources constants
 */
export const EXTERNAL_URLS = {
  /**
   * Service to get the client's IP address
   */
  IP_SERVICE: 'https://api.ipify.org/?format=json',

  /**
   * Peak travel days image URLs
   */
  PEAK_TRAVEL_IMAGES: {
    '2026': 'https://jets.s3.us-east-1.amazonaws.com/images/peak_travel_days_2026.png',
    '2027': 'https://jets.s3.us-east-1.amazonaws.com/images/peak_travel_days_2027.png',
  },
};
